
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.795","height":"15.357"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"icon data"}},[_c('path',{attrs:{"data-name":"パス 77","d":"M8.897 15.353a1.311 1.311 0 01-.93-.385L1.391 8.392a4.954 4.954 0 016.982-7.026l.524.522.5-.5a4.954 4.954 0 017.025 6.983l-.615.615a1.315 1.315 0 11-1.859-1.859l.593-.593a2.327 2.327 0 00-.1-3.265 2.321 2.321 0 00-3.21 0l-1.41 1.407a1.314 1.314 0 01-1.857 0L6.533 3.249a2.325 2.325 0 00-3.266 3.307l5.625 5.625 1.143-1.143a1.315 1.315 0 111.859 1.859L9.821 14.97a1.311 1.311 0 01-.924.383z","fill":"#0ac"}})])])
          )
        }
      }
    